import React from "react"
import { FormattedMessage } from "react-intl"
import { Typography, Link, useTheme } from "@carrotfertility/carotene-core"
import { Paths, TtcPaths } from "#/utils/Paths"

interface PartnerProvidersSectionProps {
  hasProviderFinder: boolean
  // When true, render the "Contact us for more information" fallback if the
  // member doesn't have provider finder. Enterprise opts in; consumers do not
  // (the fallback points at a Talk-to-Carrot surface that isn't part of the
  // consumer product).
  includeFallbackCopy?: boolean
}

export function PartnerProvidersSection({
  hasProviderFinder,
  includeFallbackCopy = false
}: PartnerProvidersSectionProps): JSX.Element | null {
  const theme = useTheme()

  if (!hasProviderFinder && !includeFallbackCopy) {
    return null
  }

  return (
    <>
      <Typography variant="h2" marginBottom={theme.spacing(theme.tokens.spacing.xs)}>
        <FormattedMessage defaultMessage="Save with partner providers" />
      </Typography>
      <Typography variant="body1" marginBottom={theme.spacing(theme.tokens.spacing.lg)}>
        {hasProviderFinder ? (
          <FormattedMessage
            defaultMessage='Use your member ID to access special rates, priority scheduling, and other benefits at partner providers. To get started, <link>look for providers</link> with the "Exclusive benefits" tag.'
            values={{
              link: (linkContent) => <Link href={Paths.PROVIDER_FINDER}>{linkContent}</Link>
            }}
          />
        ) : (
          <FormattedMessage
            defaultMessage="Use your member ID to access special rates, priority scheduling, and other benefits at partner providers. <link>Contact us</link> for more information."
            values={{
              link: (linkContent) => (
                <Link target="_blank" href={TtcPaths.TTC_FIND_PROVIDER}>
                  {linkContent}
                </Link>
              )
            }}
          />
        )}
      </Typography>
      <Typography variant="body1" marginBottom={theme.spacing(theme.tokens.spacing.lg)}>
        <FormattedMessage defaultMessage="You don't need your ID to receive care and services from non-partner providers. " />
      </Typography>
    </>
  )
}
